import { createContext, useContext } from 'react';
import { getPermissions } from '@/services/auth';

/**
 * Permission context and hook, split from the provider so that file exports
 * only components (React Fast Refresh requirement).
 */

export interface PermissionsApi {
  permissions: string[];
  has: (permission: string) => boolean;
  /** An empty requirement list means "any signed-in user". */
  hasAny: (permissions: string[]) => boolean;
}

export const PermissionsContext = createContext<PermissionsApi | null>(null);

export function usePermissions(): PermissionsApi {
  const ctx = useContext(PermissionsContext);
  // Falling back to storage keeps the hook usable outside the provider (tests,
  // the login screen) without every caller having to null-check.
  return (
    ctx ?? {
      permissions: getPermissions(),
      has: (p) => getPermissions().includes(p),
      hasAny: (list) => list.length === 0 || list.some((p) => getPermissions().includes(p)),
    }
  );
}
